
<script>
import Layout from '@/router/layouts/main';
import ReceptionInfo from './main.vue';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: 'Reception',
  },
  components: {
    Layout,
    ReceptionInfo,
  },
  data() {
    return {
      items: [
        {
          text: '',
          href: '/orders/manage',
        },
        {
          text: '',
          active: true,
        },
      ],
    };
  },
};
</script>

<template>
  <Layout :title="$t('general.manage')">
    <ReceptionInfo :receptionIdPublic="this.$route.params.idPublic" />
  </Layout>
</template>